/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import GlobalPortal from "./GlobalPortal.jsx";
import FloatingElement from "./FloatingElement.jsx";
import {AnimatePresence} from "motion/react";
import Unique from 'toolbox/unique';
import Algo from "toolbox/algo";
import {ErrorBoundary} from "errorBoundarys";


class Dropdown extends PureComponent {
    constructor() {
        super();

        this.state = {
            ownId: Unique.newInternalId(),
            isOpen: false
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // This is needed to prevent unwanted re-renders. Sometimes the 'isOpen' state is set multiple times to the same value, which results in animation mess.
        if (this.state.isOpen !== this.props.isOpen) {
            this.setState({isOpen: this.props.isOpen})
        }
    }

    componentDidMount() {
        if (this.state.isOpen !== this.props.isOpen) {
            this.setState({isOpen: this.props.isOpen})
        }
    }

    render() {
        let {isOpen} = this.state
        let {targetRef, width, height, placement, className, children, offsetMainAxis} = this.props

        if (width === "auto") {
            width = Algo.goldenRatioLonger(height)
        }

        if (height === "auto") {
            height = Algo.goldenRatioLonger(width)
        }

        return (
            <GlobalPortal key={this.state.ownId}>
                <AnimatePresence>
                    {isOpen && (
                        <>   {/*The order of the unmounting on exit is relevant do not change*/}
                            <FloatingElement targetRef={targetRef} width={width} height={height}
                                             offsetMainAxis={offsetMainAxis}
                                             defaultPlacement={placement}
                                             className={`bg-white  rounded-md  shadow-sm absolute w-full h-full overflow-hidden z-50 ${className ?? ""}`}>
                                <ErrorBoundary errorStyle={"small"}>
                                    {children}
                                </ErrorBoundary>
                            </FloatingElement>
                        </>
                    )}
                </AnimatePresence>
            </GlobalPortal>
        );
    }
}

Dropdown.propTypes = {
    isOpen: PropTypes.bool,
    targetRef: PropTypes.any,
    width: PropTypes.any,
    height: PropTypes.any,
    className: PropTypes.any,

};

export default Dropdown;